
import {Component, input, output} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {InfoBoxComponent, InfoBoxType, NgxHekaDynamicLinkDirective, UserDomainSummaryDTO} from "ngx-heka-design-lib";
import {MultiDomainInvitationComponent} from "../multi-domain-invitation/multi-domain-invitation.component";

@Component({
  selector: 'app-multi-domain-start',
  imports: [TranslateModule, NgxHekaDynamicLinkDirective, MultiDomainInvitationComponent, InfoBoxComponent],
  templateUrl: './multi-domain-start.component.html',
  standalone: true,
  styleUrl: './multi-domain-start.component.scss'
})
export class MultiDomainStartComponent {
  onCreateDomain = output<void>();
  onAcceptInvitation = output<UserDomainSummaryDTO>();
  onRejectInvitation = output<UserDomainSummaryDTO>();
  invitations = input.required<UserDomainSummaryDTO[]>();
  protected readonly InfoBoxType = InfoBoxType;

  constructor() {
  }

}
